import { MatchedPro } from '../types';

const MATCHER_TOP_MATCH_KEY = 'matcher_top_match';

// Written by the TaxProMatcher wizard just before it does a full-page nav to
// TaxProMatcherResults (sessionStorage is what survives that jump - there's no referral id
// to carry the way the real ReferralForm -> Results flow does). Only one match is ever in
// flight per tab, so a single fixed key is enough - no per-request id needed.
function storeMatcherTopMatch(topMatch: MatchedPro): void {
  try {
    sessionStorage.setItem(MATCHER_TOP_MATCH_KEY, JSON.stringify(topMatch));
  } catch {
    // quota exceeded or unavailable in private browsing - fail silently
  }
}

// Not cleared on read, unlike sessionStorage utils elsewhere (e.g. loadingPageHeight's
// one-shot value) - there's no server-side fallback to refetch from if the results page
// reloads, so the value should survive a refresh and only gets overwritten by the next
// wizard run.
function getMatcherTopMatch(): MatchedPro | null {
  try {
    const stored = sessionStorage.getItem(MATCHER_TOP_MATCH_KEY);
    if (stored === null) return null;
    const parsed = JSON.parse(stored) as Partial<MatchedPro>;
    // A deploy landing between the wizard's write and this read can leave a
    // pre-deploy-shaped object behind (this is a hard page nav, not an SPA route),
    // so array fields consumed via .length/.map downstream must never be trusted as-is.
    return {
      ...parsed,
      specializations: parsed.specializations ?? [],
      industriesServed: parsed.industriesServed ?? [],
      credentials: parsed.credentials ?? [],
      designations: parsed.designations ?? []
    } as MatchedPro;
  } catch {
    return null;
  }
}

export { storeMatcherTopMatch, getMatcherTopMatch };
